export default "__VITE_ASSET__CFAy_5cz__"